import React from 'react'

// Peças para replicar modelos em PDF: cada folha (`Sheet`) guarda a margem esquerda do modelo e cada bloco
// (`Block`) o seu topo, para os textos (`At`) usarem as mesmas coordenadas em pt do modelo.
export const LINE = '1pt solid #000'

const LeftContext = React.createContext(0)
const TopContext = React.createContext(0)

export const Sheet = ({ left, style, children }) => (
  <LeftContext.Provider value={left}>
    <div style={style}>{children}</div>
  </LeftContext.Provider>
)

// `borders`: "t" e/ou "b" para as linhas de cima e de baixo (as laterais ficam, salvo `plain`)
export const Block = ({ top, height, minHeight, borders = '', plain, style, children }) => (
  <TopContext.Provider value={top}>
    <div
      style={{
        position: 'relative',
        boxSizing: 'border-box',
        height: height && `${height}pt`,
        minHeight: minHeight && `${minHeight}pt`,
        borderLeft: plain ? 0 : LINE,
        borderRight: plain ? 0 : LINE,
        borderTop: borders.includes('t') ? LINE : 0,
        borderBottom: borders.includes('b') ? LINE : 0,
        ...style
      }}
    >
      {children}
    </div>
  </TopContext.Provider>
)

// Texto posicionado: `y` é o topo da linha, `w` limita a largura (com `align` para centralizar)
export const At = ({ x, y, w, size = 9, bold, italic, align, wrap, style, children }) => {
  const left = React.useContext(LeftContext)
  const top = React.useContext(TopContext)
  return (
    <div
      style={{
        position: 'absolute',
        left: `${x - left}pt`,
        top: `${y - top}pt`,
        width: w && `${w}pt`,
        fontSize: `${size}pt`,
        lineHeight: `${size}pt`,
        fontWeight: bold ? 'bold' : 'normal',
        fontStyle: italic ? 'italic' : 'normal',
        textAlign: align,
        whiteSpace: wrap ? 'normal' : 'nowrap',
        ...style
      }}
    >
      {children}
    </div>
  )
}

export const VLine = ({ x, y1, y2 }) => {
  const left = React.useContext(LeftContext)
  const top = React.useContext(TopContext)
  return (
    <div
      style={{
        position: 'absolute',
        left: `${x - left}pt`,
        top: `${y1 - top}pt`,
        height: `${y2 - y1}pt`,
        borderLeft: LINE
      }}
    />
  )
}

export const HLine = ({ x1, x2, y }) => {
  const left = React.useContext(LeftContext)
  const top = React.useContext(TopContext)
  return (
    <div
      style={{
        position: 'absolute',
        left: `${x1 - left}pt`,
        top: `${y - top}pt`,
        width: `${x2 - x1}pt`,
        borderTop: LINE
      }}
    />
  )
}
